import React from 'react';

/**
 * Loading Skeleton for Filter Sections
 * Displays animated placeholder while filter options are loading.
 * 
 * Task: P1-006
 */
const FilterSkeleton = ({ rows = 5 }) => {
  return (
    <div className="px-3 pb-3 space-y-2 animate-pulse">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="flex items-center space-x-2 p-2">
          <div className="w-4 h-4 bg-slate-200 rounded" />
          <div className="flex-1 space-y-1">
            <div className="h-4 bg-slate-200 rounded w-3/4" />
            <div className="h-3 bg-slate-100 rounded w-1/2" />
          </div>
          <div className="h-4 w-8 bg-slate-100 rounded" />
        </div>
      ))}
    </div>
  );
};

export default FilterSkeleton;
